










import Vue from 'vue';
import Snackbar from '@/components/Snackbar.vue';
import AppBar from '@/components/AppBar.vue';

export default Vue.extend({
  name: 'App',

  components: {
    Snackbar,
    AppBar
  }
});
